import { createContext, useContext } from 'react';

// ─── Typography ─────────────────────────────────────────────────────────────────
export const display = "'General Sans', 'Inter', system-ui, sans-serif";
export const sans = "'Inter', system-ui, sans-serif";
// Numbers use Inter with tabular-nums (set globally in index.css).
// The `mono` token is kept for backwards compat — value is now Inter, not a true mono.
export const mono = "'Inter', system-ui, sans-serif";

// ─── Brand colors ───────────────────────────────────────────────────────────────
export const green = '#1FAE7C';           // brand-green — logo, positive KPIs only
export const greenLight = '#E4F5EE';      // brand-green-soft — soft green wash
export const greenDark = '#0F6E56';       // green text on light bg
export const coral = '#FF6B47';           // brand-coral — CTAs, accents, active states
export const coralSoft = '#FFE8E0';       // brand-coral-soft — hover/active backgrounds
export const coralHover = '#E85530';      // brand-coral-hover — button hover

// ─── Functional data colors (DO NOT replace with brand colors) ──────────────────
export const red = '#DC4C3F';             // data-negative — over-budget, negative variance
export const redLight = '#FCEBEB';
export const redDark = '#791F1F';
export const amber = '#E89B2C';           // data-warning — budget warnings
export const amberLight = '#FFF3E0';
export const amberDark = '#8D5A0B';

// ─── Theme objects ──────────────────────────────────────────────────────────────
export const themes = {
  light: {
    bg: '#FFF8F1',                          // brand-cream
    bgSurface: '#FFFBF6',                   // brand-surface
    bgCard: '#FFFBF6',                      // brand-surface (cards)
    border: 'rgba(15, 42, 36, 0.08)',       // brand-border
    borderLight: 'rgba(15, 42, 36, 0.05)',
    borderMedium: 'rgba(15, 42, 36, 0.15)', // brand-border-strong
    textPrimary: '#0F2A24',                 // brand-ink
    textSecondary: '#6B7B77',               // brand-muted
    textMuted: '#6B7B77',                   // brand-muted
    textFaint: '#9EACA7',
    inputBg: '#FFFBF6',
    overlay: 'rgba(15, 42, 36, 0.2)',
    pillBg: '#FFE8E0',                      // brand-coral-soft
  },
  dark: {
    bg: '#0F1117',
    bgSurface: '#1A1D27',
    bgCard: '#1E2130',
    border: '#2A2D3A',
    borderLight: '#1E2130',
    borderMedium: '#3A3D4A',
    textPrimary: '#E8E8ED',
    textSecondary: '#9A9BA8',
    textMuted: '#6B6C7A',
    textFaint: '#4A4B58',
    inputBg: '#1A1D27',
    overlay: 'rgba(0,0,0,0.5)',
    pillBg: '#2A2D3A',
  },
};

export const ThemeContext = createContext(themes.light);
export const useTheme = () => useContext(ThemeContext);

// Currency context — CAD (default) or USD with BoC conversion
export const CurrencyContext = createContext({ currency: 'CAD', fxRate: 1, fxDate: null });
export const useCurrency = () => useContext(CurrencyContext);

// Legacy gray aliases (mapped to brand tokens for migration)
export const gray50 = '#FFFBF6';
export const gray100 = '#FFF8F1';
export const gray200 = 'rgba(15, 42, 36, 0.08)';
export const gray300 = 'rgba(15, 42, 36, 0.15)';
export const gray400 = '#9EACA7';
export const gray500 = '#6B7B77';
export const gray600 = '#6B7B77';
export const gray900 = '#0F2A24';
